// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"ChangePasswordPage_inputContainer__2G2aT"};